import React from "react";
import { Typography, Row, Col } from "antd";
import { LazyLoadImage } from "react-lazy-load-image-component";
import {
  CalendarOutlined,
  DollarCircleOutlined,
  PhoneOutlined,
  SafetyCertificateOutlined,
  TagOutlined
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
const { Paragraph } = Typography;

const AboutUsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      {/* Hero section with gradient background */}
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2 uppercase">
          {t("about_us.title")}
        </h1>
        <p className="text-[22px] font-bold">{t("about_us.subtitle")}</p>
      </div>

      {/* Main content section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <Row gutter={[48, 48]} align="middle">
          <Col xs={24} lg={12}>
            <div className="text-left">
              <h2 className="text-[#F00D0D] text-4xl font-bold mb-4">
                {t("about_us.company_name")} -{" "}
                <span className="text-black">
                  {t("about_us.company_tagline")}
                </span>
              </h2>

              <Paragraph className="text-base mb-6">
                {t("about_us.company_description")}
              </Paragraph>
            </div>
          </Col>

          <Col xs={24} lg={12}>
            <div className="flex items-center justify-center">
              <LazyLoadImage
                src={
                  "https://image.kkday.com/v2/image/get/w_960%2Cc_fit%2Cq_55%2Ct_webp/s1.kkday.com/product_182597/20240618063029_fIl6J/jpg"
                }
                alt={t("about_us.image_alt.main")}
                className="rounded-lg w-full h-auto object-cover"
                effect="blur"
              />
            </div>
          </Col>
        </Row>

        {/* Why apply with us section */}
        <div className="mt-20 flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="flex items-center justify-center">
            <LazyLoadImage
              src={
                "https://t4.ftcdn.net/jpg/01/80/16/95/360_F_180169551_FFcVOJbJkq2EDpmPzQTeBNgbt4XqBCNG.jpg"
              }
              alt={t("about_us.image_alt.why_apply")}
              className="rounded-lg w-full h-auto object-cover shadow-md"
              effect="blur"
            />
          </div>

          <div className="text-left">
            <h2 className="text-3xl font-bold mb-3">
              {t("about_us.why_apply.title")}
            </h2>
            <h3 className="text-[#F00D0D] text-xl font-medium mb-6">
              {t("about_us.why_apply.subtitle")}
            </h3>

            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <DollarCircleOutlined
                  style={{ fontSize: "1.2rem", color: "#F00D0D" }}
                />
                <div>{t("about_us.why_apply.no_hidden_charges")}</div>
              </li>

              {/* <li className="flex items-center gap-3">
                <BoxPlotOutlined style={{ fontSize: '1.2rem', color: '#F00D0D' }} />
                <div>{t("about_us.why_apply.on_time_delivery")}</div>
              </li> */}

              <li className="flex items-center gap-3">
                <TagOutlined style={{ fontSize: "1.2rem", color: "#F00D0D" }} />
                <div>{t("about_us.why_apply.competitive_prices")}</div>
              </li>

              <li className="flex items-center gap-3">
                <CalendarOutlined
                  style={{ fontSize: "1.2rem", color: "#F00D0D" }}
                />
                <div>{t("about_us.why_apply.timely_processing")}</div>
              </li>

              <li className="flex items-center gap-3">
                <PhoneOutlined
                  style={{ fontSize: "1.2rem", color: "#F00D0D" }}
                />
                <div>{t("about_us.why_apply.prompt_support")}</div>
              </li>

              <li className="flex items-center gap-3">
                <SafetyCertificateOutlined
                  style={{ fontSize: "1.2rem", color: "#F00D0D" }}
                />
                <div>{t("about_us.why_apply.fast_secure")}</div>
              </li>
            </ul>
          </div>
        </div>

        {/* Our core value section */}
        <div className="mt-20">
          <Row gutter={[48, 48]} align="middle">
            <Col xs={24} lg={12}>
              <div className="text-left">
                <h2 className="text-3xl font-bold mb-6">
                  {t("about_us.core_value.title")}
                </h2>

                <ul className="space-y-6">
                  <li className="flex items-start gap-3">
                    <div className="text-[#F00D0D] text-xl mt-0.5">•</div>
                    <div>{t("about_us.core_value.point1")}</div>
                  </li>

                  <li className="flex items-start gap-3">
                    <div className="text-[#F00D0D] text-xl mt-0.5">•</div>
                    <div>{t("about_us.core_value.point2")}</div>
                  </li>
                </ul>
              </div>
            </Col>

            <Col xs={24} lg={12}>
              <div className="flex items-center justify-center">
                <LazyLoadImage
                  src={
                    "https://t3.ftcdn.net/jpg/04/48/81/62/360_F_448816210_J8AitGLdzIjlzuUX6kdKA9wzayRMrNFe.jpg"
                  }
                  alt={t("about_us.image_alt.core_value")}
                  className="rounded-lg w-full h-auto object-cover shadow-md"
                  effect="blur"
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
